import api, { EnterpriseRcb } from "api";
import { AppAction, AppButton, AppGridBar, AppGridLayout, AppGridTabs, AppRow, AppSearchItem, AppTable, AppTableSearch } from 'qcc';
import React from 'react';
import EnterpriseRcbCertificateForm from './EnterpriseRcbCertificateForm';
import EnterpriseRcbEditForm from './EnterpriseRcbEditForm';
import EnterpriseRcbIntroduce from './EnterpriseRcbIntroduce';

const entAudStatus = {
  '0': '未认证',
  '1': '管理员资料已提交',
  '2': '企业基本资料(没有申请表)已提交',
  '3': '已提交待审核',
  '4': '审核通过',
  '5': '审核不通过',
  '6': '人工初审通过'
}

export default class extends React.Component {
  // 新增企业
  add = async () => {
    let projectId = 0;
    if (this.refTableSearch.current)
      projectId = (this.refTableSearch.current.state.data.projectId) || 0;
    if (projectId === 0) return;
    let formData = { projectId } as EnterpriseRcb;
    let title = '新增企业';
    let editForm = <EnterpriseRcbEditForm mode={1} formData={formData} afterSave={this.afterSave} />
    AppAction.openDialog(editForm, { title, width: 600, height: 460 });
  }
  // 编辑
  edit = async (data: any) => {
    console.log("data", data)
    let formData = await api.posenterprisercb.getOne({ id: data.id })
    console.log("formData", formData)
    let title = '编辑企业';
    let editForm = <EnterpriseRcbEditForm mode={2} formData={formData} afterSave={this.afterSave} />
    AppAction.openDialog(editForm, { title, width: 600, height: 460 });
  }

  // 注册
  enrolment = async (d: any) => {
    AppAction.coverFull();
    let data = await api.posenterprisercb.getOne({ id: d.id })

    // 先调用法大大注册接口
    let res = await api.public.fdd.register(data);
    if (!res.result) {
      AppAction.cancelCoverFull();
      AppAction.alert(res.msg);
    }

    // 获取客户ID
    console.log("先调用法大大注册接口:", res);
    data.customerId = res.data.toString();
    console.log("先调用法大大注册接口后数据:", data);

    await api.posenterprisercb.enrolment(data);

    AppAction.cancelCoverFull();
    AppAction.successMsg('注册成功!');
    this.refLoadGrid()
  }

  // 认证
  certificate = async (d: any) => {
    let formData = await api.posenterprisercb.getOne({ id: d.id });
    let title = '企业认证';
    let editForm = <EnterpriseRcbCertificateForm mode={2} formData={formData} afterSave={this.refLoadGrid} />
    AppAction.openDialog(editForm, { title, width: 600, height: 460 });
  }

  // 实名证书申请
  applyCert = async (d: any) => {
    let data = await api.posenterprisercb.getOne({ id: d.id })
    let id = data.id;
    if (await AppAction.confirm("您确定要申请实名证书吗？")) {
      let res = await api.posenterprisercb.getApplyCert(data);
      if (!res.result) {
        AppAction.cancelCoverFull();
        AppAction.alert(res.msg);
      }
      AppAction.cancelCoverFull();
      AppAction.successMsg('实名证书申请成功!');
      this.refLoadGrid()
    }

  }
  // 删除
  delete = async (data: any) => {
    if (await AppAction.confirm("您确定要删除吗？")) {
      let res = await api.posenterprisercb.delete(data);
      if (!res.result) {
        AppAction.cancelCoverFull();
        AppAction.alert(res.msg);
      }
      AppAction.cancelCoverFull();
      AppAction.successMsg('删除成功!');
      this.refLoadGrid()
    }
  }
  // 引入
  introduce = async () => {
    let projectId = 0;
    if (this.refTableSearch.current)
      projectId = (this.refTableSearch.current.state.data.projectId) || 0;
    if (projectId === 0) return;
    let formData = { projectId } as EnterpriseRcb;
    let title = '引入企业';
    let selectTable = <EnterpriseRcbIntroduce projectId={formData.projectId} callback={this.handleAddBank} />
    AppAction.openDialog(selectTable, { title, width: 800, height: 600 });
  }

  handleAddBank = async (list?: any[]) => {
    let projectId = this.refTableSearch.current.state.data.projectId
    let ids = list.map((o: any) => {
      return o.id as number;
    }) || [];
    AppAction.coverFull()
    await api.posenterprisercb.introduceList({ projectId, ids });
    AppAction.cancelCoverFull();
    AppAction.successMsg('引入成功！');
    this.afterSave()
    AppAction.closeDialog();

  }

  refLoadGrid = () => {
    this.refGrid.current && this.refGrid.current.state.refTable.fetch();
  }


  afterSave = () => {
    this.refGrid.current && this.refGrid.current.state.refTable.fetch();
    AppAction.closeDialog();
  }
  refTable = React.createRef<AppTable>();
  refGrid = React.createRef<AppGridLayout>();
  refTableSearch = React.createRef<AppTableSearch>();
  render() {
    return (
      <AppGridLayout ref={this.refGrid}>
        <AppGridLayout.SearchArea>
          <AppTableSearch ref={this.refTableSearch}>
            <AppTableSearch.Common>
              <AppSearchItem.ProjectTree keyName='projectId' projectTreeScene={6601} field='project_id' lable='项目：' />
            </AppTableSearch.Common>
          </AppTableSearch>
        </AppGridLayout.SearchArea>
        <AppGridLayout.MenuArea>
          <AppGridBar>
            <AppGridBar.Left>
              <AppGridTabs tabs={['企业列表']} />
            </AppGridBar.Left>
            <AppGridBar.Right>
              <AppRow style={{ float: 'right', marginRight: 20 }}>
                <AppButton label='新增' actionCode="66102001" type='primary' action={this.add} />
                <AppButton label='引入企业' actionCode="66102009" type='primary' action={this.introduce} />
              </AppRow>
            </AppGridBar.Right>
          </AppGridBar>
        </AppGridLayout.MenuArea>
        <AppGridLayout.GridArea>
          <AppTable paging
            sqlId='sql.enterpriseRcb.getList'
            onBeforeApi={(data: any) => { return data.projectId !== undefined }}
          >
            <AppTable.ColIndex />
            <AppTable.Col title='企业名称' field='open_name' width={300} />
            <AppTable.Col title='企业标识' field='open_id' width={300} />
            <AppTable.Col title='是否注册' align="center" width={80}
              render={
                (data: any) => {
                  return data.is_enrolment === 0 ? "否" : "是"
                }
              } />
            <AppTable.Col title='客户编号' field='customer_id' width={300} />
            <AppTable.Col title='认证状态' width={200} align="center"
              render={
                (data: any) => {
                  return entAudStatus[data.status] || '';
                }
              } />
            <AppTable.Col title='是否申请实名证书' align="center" width={180}
              render={
                (data: any) => {
                  return data.is_apply_cert === 0 ? "否" : "是"
                }
              } />
            <AppTable.ColAction render={(data: any, dataIndex: number) => {
              let { is_enabled } = data
              return (<AppRow itemSplit={10} style={{ float: 'right' }}>
                {data.is_enrolment === 0 ? <AppButton type='link' label='编辑' actionCode="66102002" action={() => this.edit(data)} /> : null}
                {data.is_enrolment === 0 ? <AppButton type='link' label='注册' actionCode="66102004" action={() => this.enrolment(data)} /> : null}
                {data.is_enrolment === 1 ? <AppButton type='link' label='认证' actionCode="66102005" action={() => this.certificate(data)} /> : null}
                {data.status === "4" && data.is_apply_cert === 0 ? <AppButton type='link' label='实名证书申请' actionCode="66102006" action={() => this.applyCert(data)} /> : null}
                {data.status === "0" || data.status === "5" ? <AppButton type='link' label='删除' actionCode="66102008" action={() => this.delete(data)} /> : null}
              </AppRow>);
            }} />
          </AppTable>
        </AppGridLayout.GridArea>
      </AppGridLayout>
    )
  }
}


// WEBPACK FOOTER //
// ./src/page/pos/enterpriseRcb/EnterpriseRcbGrid.tsx